import * as React from "react";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { selectSignIn } from "states/global-value/global-value.slice";
import "./layout-external.less";
import { LayoutExternalContainer, LayoutExternalContainerInner } from "./style/layout-external-style";
export interface ILayoutMenuPageProps {
  children?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
}

export const LayoutExternalPage = (props: ILayoutMenuPageProps) => {
  const { children } = props;
  const isLogged = useSelector(selectSignIn, shallowEqual);
  return (
    !isLogged ?
      (<LayoutExternalContainer className="bg-gray-100">
        <LayoutExternalContainerInner>
          {children}
        </LayoutExternalContainerInner>
      </LayoutExternalContainer>) : <></>
  );
};
export default LayoutExternalPage;
